module.exports = __webpack_public_path__ + "media/frontend/svg/information3-4f77685fe8f73b2676e7ba9410b9bb33.svg";